import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';
import AttendeeDetails from '../whos-here/attendees/AttendeeDetails';
import {
  fetchAttendee,
  postAttendeeNotes,
  putAttendeeNotes,
  fetchAttendeeNotes,
  postFavorite
} from '../../actions/api';
import { updateHeader, updateFavModel } from '../../actions/local';
import { selectUser } from '../../selectors/user';
import { selectCurrentEvent } from '../../selectors/events';
import { selectScannedAttendeesIds } from '../../selectors/scannedAttendees';
import { selectCanTakeNotes } from '../../selectors/scanNotesPermissions';

class ScannedAttendeeDetailsContainer extends React.Component {
  componentDidMount() {
    // Set up header with back button
    this.props.updateHeader({
      leftBtn: 'back',
      rightBtn: null
    });

    // Fetch attendee data
    const { attendeeId } = this.props.match.params;
    if (attendeeId) {
      this.props.fetchAttendee({
        attendee_id: attendeeId,
        ...this.getSharedApiParams()
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { attendeeId } = this.props.match.params;
    const prevAttendeeId = prevProps.match.params.attendeeId;

    if (attendeeId !== prevAttendeeId) {
      this.props.fetchAttendee({
        attendee_id: attendeeId,
        ...this.getSharedApiParams()
      });
    }
  }

  getSharedApiParams = () => {
    const { appId, eventId } = this.props.match.params;
    return {
      app_id: +appId,
      event_id: +eventId
    };
  };

  postAttendeeNotes = data => {
    if (data.note_id) {
      this.props.putAttendeeNotes({
        ...data,
        ...this.getSharedApiParams()
      });
    } else {
      this.props.postAttendeeNotes({
        ...data,
        ...this.getSharedApiParams()
      });
    }
  };

  fetchAttendeeNotes = data => {
    this.props.fetchAttendeeNotes({
      ...data,
      ...this.getSharedApiParams()
    });
  };

  fetchAttendee = data => {
    this.props.fetchAttendee({
      ...data,
      ...this.getSharedApiParams()
    });
  };

  render() {
    const { attendeeId } = this.props.match.params;
    const { theme, t, user, canTakeNotes, scannedAttendeesIds, event } = this.props;

    // Get attendee from scannedAttendees or whosHereAttendees
    const attendee = this.props.scannedAttendees?.[attendeeId] ||
                     this.props.whosHereAttendees?.[attendeeId];

    // Create a minimal whosHere object for compatibility
    const whosHere = {
      is_starable: event?.is_starable || false
    };

    const propsForAttendeeDetails = {
      attendee,
      attendeeId: +attendeeId,
      theme,
      t,
      user,
      matchParams: this.props.match.params,
      history: this.props.history,
      canTakeNotes,
      scannedAttendeesIds,
      whosHere,
      fetchAttendee: this.fetchAttendee,
      postAttendeeNotes: this.postAttendeeNotes,
      fetchAttendeeNotes: this.fetchAttendeeNotes,
      postFavorite: this.props.postFavorite,
      updateFavModel: this.props.updateFavModel
    };

    return <AttendeeDetails {...propsForAttendeeDetails} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: selectUser(state, ownProps),
    event: selectCurrentEvent(state, { eventId: ownProps.match.params.eventId }),
    scannedAttendeesIds: selectScannedAttendeesIds(state, ownProps),
    canTakeNotes: selectCanTakeNotes(state, ownProps),
    scannedAttendees: state.scannedAttendees || {},
    whosHereAttendees: state.whosHereAttendees || {}
  };
};

const mapDispatchToProps = {
  fetchAttendee,
  postAttendeeNotes,
  putAttendeeNotes,
  fetchAttendeeNotes,
  postFavorite,
  updateHeader,
  updateFavModel
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(withTheme(ScannedAttendeeDetailsContainer))));
